import { SB } from '@play-co/replicant';

export const puzzleWinCountSchema = {
  /**
   * Track puzzle wins count for the last 7 days
   */
  puzzleWinCount: SB.object({
    updatedAt: SB.int(),
    days: SB.array(SB.int()),
  }),
};
